import CSSStyle from '../StripePayment/index.module.css';
import ApplepayCSSStyle from './index.module.css';
import React, { useCallback, useContext } from "react";
import { JoinClassName } from '../utils/cssHelper';
import { FormattedMessage } from 'react-intl';
import { LOCAL, PaymentRequestInfo, AssetsContext, StripeAssetsContext } from '../model';
import { DisplayFormatEnum, numberFormat } from '../utils/utils';


export type ApplyPaymentPanelProps = {
    interfaceLocal: LOCAL;
    paymentRequestInfo: PaymentRequestInfo;
    onDoPayment: () => void;
    onUsingCreditCardPaymentRequest: () => void;
}
export function ApplyPaymentPanel(props: ApplyPaymentPanelProps) {
    let {
        interfaceLocal: local,
        paymentRequestInfo,
    } = props;
    let currentLanguage = local || LOCAL.EN;
    let totalPaymentAmount = paymentRequestInfo.payAmount;
    let payButtonEnable = Math.ceil(paymentRequestInfo.payAmount) > 0;
    let assetsContext = useContext<AssetsContext>(StripeAssetsContext);

    let onApplyPayPayment = useCallback(() => {
        props.onDoPayment();
    }, [props]);

    let onAddCreditCard = useCallback(() => {
        props.onUsingCreditCardPaymentRequest();
    }, [props]);

    return (<div className={JoinClassName(ApplepayCSSStyle.main,)}>
        {
            (
                <React.Fragment>
                    <div className={JoinClassName(CSSStyle.apply_pay_container)}>
                        <div onClick={payButtonEnable ? onApplyPayPayment : () => { }} className={JoinClassName(CSSStyle.apply_pay_button)}>
                            <div className={JoinClassName(CSSStyle.desc)}><FormattedMessage id="check_out_with_prefix" /></div>
                            <div className={JoinClassName(CSSStyle.apply_pay_icon)}></div>
                            <div className={JoinClassName(CSSStyle.desc)} style={currentLanguage === LOCAL.ZH ? { paddingRight: '2px' } : {}}>
                                <FormattedMessage id="check_out_with_suffix" /></div> • ${numberFormat((totalPaymentAmount || 0) / 100, DisplayFormatEnum.DECIMAL, 2)}
                        </div>
                    </div>
                    <div className={JoinClassName(assetsContext.assetsSetting.entryCardNumberLabelClass || CSSStyle.credit_card_pay_entry)} onClick={onAddCreditCard}>
                        <FormattedMessage id="Enter_Card_Number_Manually" />
                    </div>
                </React.Fragment>
            )
        }</div>);
}